import React from 'react'
import ProductImage from '../assets/productImg.png'
import AdvocacyIcon from '../assets/advocacy.svg'
import PerformanceIcon from '../assets/performance.svg'
import CommitmentIcon from '../assets/commitment.svg'
import TransperancyIcon from '../assets/transperancy.svg'
import FunIcon from '../assets/fun.svg'
import AllProducts from '../components/AllProducts'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { appRoutes } from '../utils/app_routes'


const Home = () => {

    const navigate = useNavigate()

    const featuresData = [
        {
            img: TransperancyIcon,
            name: 'Transparency',
            desc: 'We talk the talk, with science.'
        },
        {
            img: PerformanceIcon,
            name: 'Performance',
            desc: 'Driven to out-best ourselves.'
        },
        {
            img: CommitmentIcon,
            name: 'Commitment',
            desc: 'Here to address diverse wellness needs'
        },
        {
            img: AdvocacyIcon,
            name: 'Advocacy',
            desc: 'Our truth is to create an honest dialogue around health.'
        },
        {
            img: FunIcon,
            name: 'Fun',
            desc: 'We’re not shy about debunking the wellness industry.'
        },
    ]

    const handleScroll = () => {
        window.scrollTo({ behavior: 'smooth', top: 912 })
    }

    return (
        <div>
            <Helmet>
                <title>Supreme Nutra Shop</title>
                <meta name="description" content="This is a detailed description of the page content for better SEO" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Supreme Nutra Shop" />
                <meta property="og:description" content="This is a detailed description of the page content for better SEO" />
                <meta property="og:image" content="https://www.example.com/image.jpg" />
                <link rel="canonical" href="https://www.example.com/page" />
            </Helmet>
            <div className="w-[102%] h-[90vh] xl:h-[calc(100dvh-110px)] background-hero text-white flex items-center justify-start px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%]">
                <div className='w-0 xl:basis-1/2'></div>
                <div className='w-full md:-ms-8 xl:basis-1/2 text-center xl:text-start '>
                    <p className='text-[30px] md:text-[48px] font-[600] leading-[normal] '>Supreme Nutra Shop: <br />Essentials for Your Best Self</p>
                    <button className='btn-primary caption-bottom mt-[30px]' onClick={handleScroll}>shop best sellers</button>
                </div>
            </div>
            <AllProducts />
            <div className='h-[660px] w-full bg-fit-ball py-[30px] md:py-[121px] px-[30px] xl:px-[10%] 2xl:px-[12.6%]'>
                <div className='h-[480px] xl:h-[418px] border-primary border-[4px] w-full text-white p-5 xl:p-20 text-start flex flex-col xl:flex-row'>
                    <div className='flex flex-col gap-[10px] w-full xl:w-[50%]'>
                        <p className='text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>Unleash your potential</p>
                        <p className='text-[14px] sm:text-[16px] font-normal leading-[26px]'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                        <div className='mt-[14px]'>
                            <button onClick={() => navigate(appRoutes.shop)} className='btn-primary'>Shop Now</button>
                        </div>
                    </div>
                    <div className='flex w-full justify-end xl:w-[50%]'>
                        <div className='mt-5 xl:mt-5 flex xl:block justify-end '>
                            <img src={ProductImage} alt="ProductImage" className='w-[50%] xl:w-full xl:h-[400px]' />
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-white text-center md:py-[100px] p-10 w-full'>
                <div className='flex w-full items-center justify-center'>
                    <div className='text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)] max-w-[796px]'>
                        <span className='text-black'>In truth and science, we're debunking the </span>
                        <span className='text-primary'>wellness industry.</span>
                    </div>
                </div>
                <div className='mt-[50px] flex items-center flex-wrap justify-center gap-[25px]'>
                    {
                        featuresData.map((item, inx) => {
                            return (
                                <div className='p-[35px] min-h-[256px] flex flex-col items-center h-[262px] bg-black text-white rounded-[20px]' key={inx}>
                                    <img src={item.img} alt={item.name} className='w-[74px] h-[74px]' />
                                    <div className='mt-[14px]'>
                                        <p className='text-[24px] font-[700] leading-[normal] '>{item.name}</p>
                                        <p className='text-[15px] font-[400] leading-[normal] text-[#B2B2B2] max-w-[196px] '>{item.desc}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Home